import { render } from "./ContextMenuComponent.vue?vue&type=template&id=5cc3b190"
import script from "./ContextMenuComponent.vue?vue&type=script&lang=js"
export * from "./ContextMenuComponent.vue?vue&type=script&lang=js"

import "./ContextMenuComponent.vue?vue&type=style&index=0&id=5cc3b190&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__